<template>
    <div v-if="field">
        <b-row>
            <b-col :log="colSize">
                <b-form-group>
                    <v-select
                        :options="items"
                        @search="fetchPaginate"
                        :filterable="false"
                        :required="true"
                        v-model="content"
                        :loading="items == null"
                    >
                        <li slot="list-footer" class="pagination">
                            <b-button @click="currentPage--" style="margin-right: 10px"> < </b-button>
                            
                            <b-button @click="currentPage++"> > </b-button>
                        </li>
                    </v-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
    </div>
</template>

<style scoped lang="scss">
.pagination {
    margin-top: 10px;
}
</style>

<script>
import vSelect from 'vue-select'
import axios from 'axios'
import safeEval from 'safe-eval'
import _ from 'lodash'
import { Context } from "@protokol/platform-libs"

import "vue-select/src/scss/vue-select.scss";

export default {
    name: "IdentityFieldSelectExternal",
    components: {
        vSelect
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Object,
            default: function() {
                return {
                    value: ""
                }
            }
        },
        store: {
            type: Object
        },
        context: {
            type: Object
        },
        translation: {
            type: Function
        }
    },
    data: function() {
        return {
            items: [],
            errors: [],
            renderError: false,
            currentPage: 1,
            search: '',
        }
    },
    computed: {
        content: {
            get() {
                return this.value
            },

            set(val) {
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        },

        hasNextPage() {
            return this.currentPage < this.pages
        },

        hasPrevPage() {
            return this.currentPage > 1
        },

        colSize() {
            if (this.$slots.length > 0) {
                return 10
            }

            return 12
        }
    },
    watch: {
        content(val) {
            this.check(val)
        },

        currentPage() {
            this.fetchPaginate(this.search)
        },

        "context.model": {
            handler: _.debounce(function(val, valOld) {
                if (JSON.stringify(val) != JSON.stringify(valOld)) {
                    this.fetchPaginate("")
                }
            }, 500),

            deep: true
        }
    },
    methods: {
        check(val) {
            this.errors = []

           if (this.constraints.required) {
                if (val == "") {
                    this.errors.push(this.translator("identityField.requiredField"))
                }

                let found = this.items.find(i => {
                    if (typeof i == "object") {
                        return i.value == val
                    } else {
                        return i == val
                    }
                })

                if (found === undefined) {
                    this.errors.push(this.translator("identityField.invalidSelection"))
                }  
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },

        fetchPaginate: _.debounce(function(search) {
            this.search = search;

            let results = safeEval("(function() { try { return new Promise((resolve, reject) => {"+this.constraints.custom_data.external.expression+" }); } catch (err) { console.log(err) } }());", {
                context: new Context({...this.context, vars: this.field.context}),
                keyword: search,
                pagination: {currentPage: this.currentPage},
                get: this.get
            })

            results.then(data => {
                this.items = data;
            })
        }, 500),

        get: async (url, params) => {
            return await axios(url, params)
        }
    },
    
    created() {
        this.fetchPaginate('')
    },

    mounted() {
        this.check(this.content)
        this.$emit('input', this.content)
    }
}
</script>